/* PUNIVERSE build — offer popup.

   Deliberately quiet: it waits, it takes no for an answer, and it remembers. The version this
   replaces fired on every exit and had no memory at all.

   ponytail: ~70 lines of DOM, no library. Rules it follows —
     - never on cart or checkout, where an offer interrupts a purchase in progress
     - never twice inside the remember window, and never again once someone subscribes
     - exit-intent only on a device with a real pointer; there is no such gesture on a phone
     - Escape closes it, focus moves to the field on open and back to the page on close
     - if the section rendered in its thank-you state (Shopify reloads after the form posts),
       show it straight away and record the subscribe so it never returns
*/
(function () {
  var root = document.querySelector('[data-ge-popup]');
  if (!root) return;

  var KEY = 'ge-popup-seen';
  var card = root.querySelector('.gepop__card');
  var days = parseInt(root.dataset.days, 10) || 30;
  var delay = parseInt(root.dataset.delay, 10);
  var wantsExit = root.dataset.exitIntent === 'true';
  var lastFocus = null;
  var shown = false;
  var subscribed = false;

  function remember(value) {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {
      /* private browsing — the popup simply behaves as if it were the first visit */
    }
  }

  function suppressed() {
    if (/\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return true;
    try {
      var v = localStorage.getItem(KEY);
      if (!v) return false;
      if (v === 'subscribed') return true;
      return Date.now() - parseInt(v, 10) < days * 864e5;
    } catch (e) {
      return false;
    }
  }

  function open() {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    // next frame so the transition has a state to move from
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    var field = root.querySelector('.gepop__input');
    if (field) field.focus({ preventScroll: true });
  }

  function close() {
    root.classList.remove('is-open');
    // Closing the thank-you card must not downgrade 'subscribed' to a timestamp, or someone who
    // just gave us their email would be asked again in `days` time.
    if (!subscribed) remember(String(Date.now()));
    window.setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // Close handlers are wired FIRST, before any early return below. They used to sit at the bottom,
  // which meant the thank-you branch returned before reaching them and the success card had no
  // working close button, no working X and no Escape — subscribing trapped the visitor behind a
  // modal they could not dismiss. Anything that can dismiss the dialog must be bound before any
  // code path that can skip it.
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ge-popup-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
  // keep tabbing inside the card while it is open
  card.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = card.querySelectorAll('button, input, a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  // The form posted and Shopify re-rendered the page in the thank-you state: show it, and never
  // ask this person again. Closing is already wired above, so the visitor can always get out.
  if (root.querySelector('[data-ge-popup-success]')) {
    subscribed = true;
    remember('subscribed');
    open();
    return;
  }

  if (suppressed()) return;

  // Shopify's cookie consent banner is a legal gate and has to come first. This popup used to
  // open on its own timer regardless, so on a phone the consent panel landed on top of the offer
  // and a first-time visitor met two stacked modals before seeing the shop. We now hold until
  // consent has been answered.
  //
  // The Customer Privacy API is authoritative but loads asynchronously, so fall back to looking
  // for the banner itself (#shopify-pc__banner) when the API is not up yet.
  function consentPending() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === 'function') return cp.shouldShowBanner();
    } catch (e) {
      /* API present but not ready — fall through to the DOM check */
    }
    var el = document.querySelector('#shopify-pc__banner');
    return !!(el && el.offsetParent !== null);
  }

  // Re-arming poll rather than the visitorConsentCollected event: one mechanism covers the
  // banner being answered, dismissed, or never shown at all, with no dependency on event
  // timing. Capped, so somebody who simply ignores the banner is never interrupted — that is
  // the right outcome, not a failure.
  var held = 0;
  function requestOpen() {
    if (shown) return;
    if (consentPending()) {
      if (held < 90000) {
        held += 1000;
        window.setTimeout(requestOpen, 1000);
      }
      return;
    }
    open();
  }

  if (!isNaN(delay) && delay > 0) window.setTimeout(requestOpen, delay * 1000);

  if (wantsExit && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      // relatedTarget is null when the pointer leaves the window rather than crossing an element
      if (!e.relatedTarget && e.clientY <= 0) requestOpen();
    });
  }
})();
